import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ModalConfirmation from '../../modules/procedures/components/Modal/Modal';
import { ModalUpdateView } from './ModalUpdateView';
import { Creators as utpAds } from '@/domain/useCases/getUtpAdsData/index';

const ModalUpdateController = () => {
  let enable = localStorage.getItem('modalState');
  if (enable === null) {
    localStorage.setItem('modalState', 'true');
    enable = 'true';
  }
  const [showModalUpdate, setShowModalUpdate] = useState(enable === 'true');

  const history = useHistory();
  const dispatch = useDispatch();

  const { data: utpAdsData = {} } = useSelector(
    (state: any) => state.getUtpAdsData
  );
  const DataUtpAds = utpAdsData ?? {};

  useEffect(() => {
    dispatch(utpAds.getUtpAdsData());
  }, []);

  const disableModal = () => {
    localStorage.setItem('modalState', 'false');
  };

  const handleClose = () => {
    disableModal();
    setShowModalUpdate(false);
  };

  const goToUpdate = () => {
    if (DataUtpAds.isInternal) {
      history.push(DataUtpAds.target);
    } else {
      window.open(DataUtpAds.target, '_blank');
    }
    setShowModalUpdate(false);
    disableModal();
  };
  return (
    <div id="modalSurvey" style={{ zIndex: 1000, position: 'relative' }}>
      <ModalConfirmation
        show={showModalUpdate && Object.keys(DataUtpAds).length > 0}
        handleClose={handleClose}
      >
        <ModalUpdateView
          data={DataUtpAds}
          goToUpdate={goToUpdate}
          handleClose={handleClose}
        />
      </ModalConfirmation>
    </div>
  );
};

export default ModalUpdateController;
